module.exports = __webpack_public_path__ + "static/slovnicek-project-management-f246bfe4cff58ff8d057eb3e9c27dab8.jpg";